export const amountCurrencyField = currencyObject => {
  const fieldFromCurrency = currencyObject?.amount
  if (!currencyObject || !fieldFromCurrency) return 0

  return fieldFromCurrency
}
